import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './langues/en.json';
import fr from './langues/fr.json';
import ru from './langues/ru.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ru: { translation: ru }
    },
    lng: 'fr', 
    fallbackLng: 'fr',
    interpolation: { escapeValue: false }
  });

export default i18n;